import React, { type ReactNode, type FC, useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { observer } from 'mobx-react-lite';
import { Button } from '@g2u/ui-kit';
import { Alert } from 'antd';

import { RootStore, BookingStore } from 'store';
import { JsonDataItem, type WithOptionalDataTest } from 'types';

export namespace ErrorBox {
  export type Props = {
    title?: ReactNode;
    description?: ReactNode;
    action?: () => void;
    actionTitle?: string;
    error: JsonDataItem;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { title, description, action, error } = props;

    useEffect(() => {
      datadogRum.addError(error, {
        errorInfo: error.message,
        errorSource: `API: ${error?.response?.status}`,
        extraInfo: {
          requestUrl: error?.response?.url,
          rootStore: RootStore,
          bookingStore: BookingStore,
        },
        // @ts-expect-error connection only defined in some browsers, hence type error
        connection: navigator.connection,
        online: navigator.onLine,
      });
    }, []);

    return (
      <Alert
        description={title}
        message={description}
        type="error"
        style={{ borderRadius: 6 }}
        action={
          action ? (
            <Button.$
              size={Button.Size.Small}
              type={Button.Type.Primary}
              onClick={action}
              dataTestId="resolve-error-btn"
            >
              Retry
            </Button.$>
          ) : undefined
        }
      />
    );
  });
}
